import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'

interface Options {
  shiftId: string,
  serialId: number,
}

export const apiShiftGetSMI = ({
  shiftId,
  serialId,
}: Options) => {
  const data = {
  }
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/v2/smi?shiftID=${shiftId}`,
    data,
    params: {
      reqSid: serialId,
    }
  }
  return ax(options)
}